import React from 'react'
import {Badge} from '../..'

import './operation.css'
import { CallRounded } from '@mui/icons-material'

const Operation = () => {

  return (
    <>
        <div className='operation-wrapper'>
            <Badge title="Hours of Operation" />
            <div className='operation-container'>
                <h2 className="operation-title">24/7 care & support. Tours available by appointment. Office hours: Mon-Fri 9am-5pm, Sat-Sun by appt.</h2>
                <a href="tel:+14693262931" className="hero-call-to-action-link">
                    <CallRounded className="hero-call-to-action-btn" />
                    Call and schedule a Tour: 
                    <span className='hero-call-to-action-link-title'> +214-254-6367</span>
                </a>
            </div>
        </div>
    </>
  )
}

export default Operation